import { Box } from "@mui/material";
import { useStore } from "@tanstack/react-form";
import type React from "react";
import { useCallback, useEffect, useRef } from "react"; // Import useCallback
import { useOverview } from "../../../hooks/useOverview.ts";
import { ActiveFilters } from "../home-page/ActiveFilters.tsx";
import { AttributeFilter } from "../home-page/AttributeFilter.tsx";
import { MapFilter } from "../home-page/MapFilter.tsx";
import { Results } from "../home-page/Results.tsx";
import { TilesFilter } from "../home-page/TilesFilter.tsx";
import { useHomeFilter } from "../../../hooks/useHomeFilter.ts";
import { useAllAds } from "../home-page/attribute-filter/hooks.ts";
import SzBackdrop from "../UISharedConstructors/Loading/SzBackDrop.tsx";

function scrollToRef(ref: React.RefObject<HTMLDivElement | null>) {
  ref.current?.scrollIntoView({behavior: "smooth", block: "start"});
}

export const HomePage: React.FC = () => {
	const overviewForm = useOverview();
  const homeFilter = useHomeFilter(overviewForm);

  const rootRef = useRef<HTMLDivElement>(null);
	const mapFilterRef = useRef<HTMLDivElement | null>(null);
	const attributeFilterRef = useRef<HTMLDivElement | null>(null);
	const resultsRef = useRef<HTMLDivElement | null>(null);


  const {result: allAds, query: allAdsQuery} = useAllAds(homeFilter.parsedFilter);

  const initialLoading = useRef(true);
  if (initialLoading.current) {
    if (allAdsQuery.isFetched) {
      initialLoading.current = false;
    }
  }

  if (initialLoading.current) {
    return (
      <Box height="30em">
        <SzBackdrop message={"Načítáme inzeráty"}/>
      </Box>
    );
  }

	return (
		<Box ref={rootRef} flexDirection="column" display="flex" gap="3em" component="section" overflow="hidden">
			<TilesFilter
        overviewForm={overviewForm}
        onTileClick={() => {
          scrollToRef(mapFilterRef);
          homeFilter.manualSearch();
        }}
      />
			<Box ref={mapFilterRef} sx={{ scrollMarginTop: "2em" }}>
				<MapFilter
          overviewForm={overviewForm}
          onMapClick={() => {
            scrollToRef(attributeFilterRef);
            homeFilter.manualSearch();
          }}
        />
			</Box>
			<Box ref={attributeFilterRef} sx={{ scrollMarginTop: "2em" }}>
				<AttributeFilter
          overviewForm={overviewForm}
          allAds={allAds}
        />
			</Box>
			<ActiveFilters
        overviewForm={overviewForm}
        homeFilter={homeFilter}
        onClickReset={() => {
          homeFilter.manualSearch();
          scrollToRef(rootRef);
        }}
        onClickFiltrovat={() => {
          homeFilter.manualSearch();
          scrollToRef(resultsRef);
        }}
      />
			<Box ref={resultsRef} sx={{ scrollMarginTop: "2em" }}>
				<Results overviewForm={overviewForm} searchFilter={homeFilter.parsedFilter} />
			</Box>
		</Box>
	);
};
